<template>

<div class="p-chip p-component mb-2" @click="indetify">
<template v-if="loading">
<ProgressSpinner style="width:25px;height:25px" strokeWidth="3" color="deneme" />
</template>
<div class="p-chip-text" v-if="!loading" v-html="name"></div>
<span tabindex="0" class="p-chip-remove-icon pi pi-times-circle" @click="removeItem"></span>
</div>	
</template>

<script>
export default {

  name: 'RemovableChip',
  props:["item"],
  data () {
    return {
    	loading:true,
    	name:null,
    	flow:null,
    	project:null,
    	period:null,
    	inputfield:null,
    	section:null,
    	nonconformity:null,
    	calculation:null,
    }
  },
  computed:{
  	itemid()
  	{
  		return this.item.stack_id
  	}
  },
  watch:{
  	itemid(newval)
  	{
  		this.runMount()
  	}
  },
  async mounted()
  {
  	//console.log(this.item)
  	this.runMount()
  	
  },
  methods:{
  	indetify()
  	{
  		console.log(this.item)
  	},
  	async runMount()
  	{
  		if(this.item.type=="verification_auditor")
  		{
  			await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Doğrulama Denetçisi</b> - "+this.period.period.name
		  	this.loading = await false
  		}

  		if(this.item.type=="audit_auditor")
  		{
  			await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Denetleme Denetçisi</b> - "+this.period.period.name
		  	this.loading = await false
  		}

  		if(this.item.type=="verification_date")
  		{
  			await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Doğrulama Tarihi</b> - "+this.period.period.name
		  	this.loading = await false
  		}

  		if(this.item.type=="audit_date")
  		{
  			await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Denetleme Tarihi</b> - "+this.period.period.name
		  	this.loading = await false
  		}

  		if(this.item.type=="verification_status")
  		{
  			await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Doğrulama Durumu</b> - "+this.period.period.name
		  	this.loading = await false
  		}

  		if(this.item.type=="audit_status")
  		{
  			await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Denetleme Durumu</b> - "+this.period.period.name
		  	this.loading = await false
  		}



  		if(this.item.type=='supplier_location')
  		{
  			this.name ="<b class='text-purple-500'>Tedarikçi Adresi</b> - "+this.item.name
  			this.loading = await false
  		}

  		if(this.item.type=='last_supplier_conversation')
  		{
  			if(this.item.conversation_output_type=="all")
  			{
  				this.name ="<b class='text-purple-500'>Son Tedarikçi Görüşmesi</b> - Hepsi"
  			}
  			else if (this.item.conversation_output_type=="general") 
  			{
  				this.name ="<b class='text-purple-500'>Son Tedarikçi Görüşmesi</b> - Genel"
  			}
  			else
  			{
  				await this.getOnlyProjectName()
					this.name = " <b class='text-purple-500'>Son Tedarikçi Görüşmesi</b> - "+this.project.name
		  		this.loading = await false
  			}
  			
  			this.loading = await false
  		}

  		if(this.item.type=="supplier_users")
  		{
  			if(this.item.user_output_type=="first_user")
  			{
  				this.name ="<b class='text-purple-500'>İlk Tedarikçi Kullanıcısı</b> "
  			}

  			if(this.item.user_output_type=="all_users")
  			{
  				this.name ="<b class='text-purple-500'>Tüm Tedarikçi Kullanıcıları</b> "
  			}
  			
  			this.loading = await false
  		}
	  	if(this.item.type=='project_status')
			{
				await this.getProjectName()
				this.name = this.project.name+" - <b class='text-purple-500'>Proje Durumu</b> - "+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='project')
			{
				await this.getProjectName()
				this.name = this.project.name+" <b class='text-purple-500'>Projesi</b> - "+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='flow_status')
			{
				await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Aşama Durumu</b> - "+this.period.period.name
		  	this.loading = await false
			}

			if(this.item.type=='flow')
			{
				await this.getFlowName()
				this.name = this.flow.name+" <b class='text-purple-500'>Aşaması</b> - "+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='inputfield_point')
			{
				await this.getInputfieldName()
				this.name = this.inputfield.name+" - <b class='text-purple-500'>Aşama Soru Puanı</b> - "+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='custom_attribute')
			{
				this.name = this.item.name
				this.loading = await false
			}
			if(this.item.type=='questionlist_points')
			{
				await this.getFlowName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Aşama Puanı</b> - "+this.period.period.name
		  	this.loading = await false
			}

			if(this.item.type=='questionlist_custom_points')
			{
				await this.getFlowName()
				await this.getCalculationName()
				this.name = this.flow.name+" - <b class='text-purple-500'>Aşama Özel Puanı</b> - <b class='text-purple-500'>"+ this.calculation.name+ "</b> - " +this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='section_points')
			{
				await this.getInputfieldSectionName()
				await this.getInputfieldName()
				await this.getFlow(this.item.flow_id)
				this.name = this.section.name+" - <b class='text-purple-500'>Aşama Bölüm Puanı</b> - "+this.flow.name + "-"+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='section_nonconformities')
			{
				await this.getInputfieldSectionName()
				await this.getInputfieldName()
				await this.getNonconformityType()
				let output_type
				if(this.item.nonconformity_output_type=="all_count")
				{
					output_type = " - <b class='text-purple-500'>Tamamının sayısı</b> - "
				}
				if(this.item.nonconformity_output_type=="open_count")
				{
					output_type = " - <b class='text-purple-500'>Açık sayısı</b> - "
				}
				if(this.item.nonconformity_output_type=="closed_count")
				{
					output_type = " - <b class='text-purple-500'>Kapalı  sayısı </b>- "
				}
				if(this.item.nonconformity_output_type=="refused_count")
				{
					output_type = " - <b class='text-purple-500'>Reddedilen  sayısı </b>- "
				}
				if(this.item.nonconformity_output_type=="pending_count")
				{
					output_type = " - <b class='text-purple-500'>Bekleyen  sayısı </b>- "
				}
				if(this.item.nonconformity_output_type=="accepted_count")
				{
					output_type = " - <b class='text-purple-500'>Kabul edilen  sayısı </b>- "
				}
				

				this.name = this.section.name+" - <b class='text-purple-500'>Aşama Bölüm Uygunsuzluk Sayısı</b> - "+this.nonconformity.name+output_type+this.period.period.name



		  	this.loading = await false
			}
			if(this.item.type=='inputfield_point')
			{
				await this.getInputfieldName()
				
				this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.flow_id)
				
				this.name = this.item.name+" - " +this.flow.name+" - <b class='text-purple-500'>Aşama Soru Puanı</b> -"+this.period.period.namev
		  	this.loading = await false
			}

			if(this.item.type=='inputfield_nonconformity_count')
			{
				await this.getInputfieldName()
				this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.flow_id)
				this.name = this.item.name+" - " +this.flow.name+" - <b class='text-purple-500'>Aşama Soru Uygunsuzluk Durumu</b> -"+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='inputfield_submission')
			{
				await this.getInputfieldName()
				console.log("inputfieldsname")
				console.log(this.period)
				this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.flow_id)
				await console.log(this.item)
				this.name = this.item.name+" - " +this.flow.name+" - <b class='text-purple-500'>Aşama Soru Verisi</b> -"+this.period.period.name
		  	this.loading = await false
			}

			if(this.item.type=='inputfield_null_reason')
			{
				await this.getInputfieldName()
				this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.flow_id)
				await console.log(this.item)
				this.name = this.item.name+" - " +this.flow.name+" - <b class='text-purple-500'>Aşama Soru Boş Bırakma Nedeni</b> -"+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='inputfield_auditor_note')
			{
				await this.getInputfieldName()
				this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.flow_id)
				await console.log(this.item)
				this.name = this.item.name+" - " +this.flow.name+" - <b class='text-purple-500'>Aşama Soru Denetçi Notu</b> -"+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='inputfield_supplier_note')
			{
				await this.getInputfieldName()
				console.log("inputfieldsname")
				console.log(this.period)
				this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.flow_id)
				await console.log(this.item)
				this.name = this.item.name+" - " +this.flow.name+" - <b class='text-purple-500'>Aşama Soru Boş Tedarikçi Açıklaması</b> -"+this.period.period.name
		  	this.loading = await false
			}
			if(this.item.type=='questionlist_nonconformity_count')
			{
				await this.getFlowName()
				await this.getNonconformityType()
				let output_type
				if(this.item.nonconformity_output_type=="all_count")
				{
					output_type = " - <b class='text-purple-500'>Tamamının sayısı</b> - "
				}
				if(this.item.nonconformity_output_type=="open_count")
				{
					output_type = " - <b class='text-purple-500'>Açık sayısı</b> - "
				}
				if(this.item.nonconformity_output_type=="closed_count")
				{
					output_type = " - <b class='text-purple-500'>Kapalı  sayısı </b>- "
				}
				if(this.item.nonconformity_output_type=="refused_count")
				{
					output_type = " - <b class='text-purple-500'>Reddedilen  sayısı </b>- "
				}
				if(this.item.nonconformity_output_type=="pending_count")
				{
					output_type = " - <b class='text-purple-500'>Bekleyen  sayısı </b>- "
				}
				if(this.item.nonconformity_output_type=="accepted_count")
				{
					output_type = " - <b class='text-purple-500'>Kabul edilen  sayısı </b>- "
				}
				this.name = this.flow.name+" - <b class='text-purple-500'>Aşama Uygunsuzluk Sayısı</b> - "+this.nonconformity.name+output_type+this.period.period.name
		  	this.loading = await false
			}
  	},
  	removeItem()
  	{
  		//this.$emit.removeItem(this.item)
  		//console.log(this.item)
  		//console.log(this.period.name)
  		this.$emit('removeItem', this.item.stack_id,this.item.type)
  	},
  	async getProjectName()
  	{
  		this.project = await this.generalApiGetWithoutLoader("project/"+this.item.id)
  		this.period = await this.generalApiGetWithoutLoader("projectperiod/"+this.item.period_id)  		
  	},
  	async getOnlyProjectName()
  	{
  		this.project = await this.generalApiGetWithoutLoader("project/"+this.item.conversation_output_type) 		
  	},
  	async getFlow(id)
  	{
  		this.flow = await this.generalApiGetWithoutLoader("flow/"+id)
  		
  	},
  	async getFlowName()
  	{
  		this.flow = await this.generalApiGetWithoutLoader("flow/"+this.item.id)
  		this.period = await this.generalApiGetWithoutLoader("projectperiod/"+this.item.period_id)
  	},
  	async getCalculationName()
  	{
  		this.calculation = await this.generalApiGetWithoutLoader("questionlistsametypecalculation/"+this.item.custom_calculation_id)
  	},

  	async getNonconformityType()
  	{
  		if(this.item.nonconformitytype=="all")
  		{
  			this.nonconformity = await {name:"Bütün Türler",id:"all"}
  		}
  		else
  		{
  			this.nonconformity = await this.generalApiGetWithoutLoader("questionlistnonconformitytype/"+this.item.nonconformitytype)
  		}
  		
  	},
  	async getInputfieldName()
  	{
  		this.inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+this.item.id)
  		this.period = await this.generalApiGetWithoutLoader("projectperiod/"+this.item.period_id)
  		console.log("getInputfieldName")
  		//console.log(this.inputfield)
  		//console.log(this.period)
  	},
  	async getInputfieldSectionName()
  	{
  		this.section = await this.generalApiGetWithoutLoader("questionlists/section/"+this.item.id)
  		this.period = await this.generalApiGetWithoutLoader("projectperiod/"+this.item.period_id)
  		console.log("getInputfieldSectionName")
  		//console.log(this.inputfield)
  		//console.log(this.period)
  	},
  	async getFlowData()
  	{
  		
  		this.inputfieldcolumns = await this.generalApiGetWithoutLoader("questionlists/inputfield/columns/"+this.selected_inputfield.id)
  	} 
  }
}
</script>

<style lang="css" scoped>
</style>